<div *ngIf="parentView?.mode && dataTypes?.length > 0 && dataKeys?.length > 0" class="data-model-holder">
  {{item.label}} {{dataTypesOptions.length}}
  <p-select ngDefaultControl (onChange)="updateRelated()" [virtualScroll]="true" [virtualScrollItemSize]="20" [options]="dataTypesOptions" placeholder="Related Data Type"
    [(ngModel)]="selectedType" optionLabel="label" optionValue="value" />
  <div class="form-field flex-row">
    <div class="flex-column-1" style="margin: 5px 0;">
    <p-autocomplete ngDefaultControl (completeMethod)="filter($event)" (onSelect)="updateKey()"
      [suggestions]="filteredKeys" placeholder="Key" [(ngModel)]="selectedKey" optionLabel="name" optionValue="name"
      fluid [ngClass]="{'ng-invalid ng-dirty': error}"
      />
      </div>
    <p-button severity="primary" *ngIf="!existing(selectedKey)" (click)="addNewKey()"
      [disabled]="error" aria-label="Create Key" pTooltip="Create Key">
      <i class="fas fa-plus"></i>
    </p-button>
  </div>
  <div class="error-msg" *ngIf="error">Key name cannot contain white spaces.</div>
</div>
